import script from "./object_dayCollectionLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./object_dayCollectionLocation.vue?vue&type=script&setup=true&lang=js"

import "./object_dayCollectionLocation.vue?vue&type=style&index=0&id=c192f8ae&lang=css&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c192f8ae"]])

export default __exports__